import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";
import { getSelectableTemplates } from "web_myplann/Reminders/Utils/getSelectableTemplates";

export const getEditableTemplates = (
	templates: ReminderTemplate[],
	entityConfig: ReminderEntityConfig,
	validTo: Date | null | undefined,
	currentTypeKey: string | undefined,
	today?: Date,
): ReminderTemplate[] => {
	const selectable = getSelectableTemplates(
		templates,
		entityConfig,
		validTo,
		today,
	);

	return templates.filter(
		(template) =>
			selectable.includes(template) || template.typeKey === currentTypeKey,
	);
};
